<template>
	<div class='contact sections' name="contact" id="contact">
		<div class='contact_left'>
			<div class='photo'>
				<img height=250px src='photos/me.png' alt='Profile Picture of Chester Enright' /><br
					class='clear' />
			</div>
			<div class='text'>
				<b>Chester Enright<br />
					<a href='tel:+12176438224'>(217) 643-8224</a><br /></b><br />
				<a href='mailto:chet.enright@gmail.com'>chet.enright@gmail.com</a><br />
				<br />
				<br />
				Like what you see here?<br />Feel free to give me a call or email<br /> and we can talk!
			</div>
		</div>
		<div class='contact_right'>
			<h2>Enough about Me! Let's Talk about You!</h2>
			<form id='contact_form' ref="form" :action="url" method="POST">
				<!--<input type='hidden' id='random' value='<?=$captchas->random()?>' />-->
				<div class='contact_form'>
					<div class='top_row'>
						<input name="name" type='text' id='Name' :placeholder="name" />
						<input name="_replyto" type='text' id='Email' :placeholder="email">
					</div>
					<textarea name="message" id='Message' cols=45 rows=7
						:placeholder="msg"></textarea>
					<div class='submit_button' @click="sendEmail()">SEND TO CHET</div>
				</div>
			</form>

			<!-- modify this form HTML and place wherever you want your form -->
			<br /><br />
		</div>


		<br class='clear' />

		<div class='legal'>
			© {{ year }} - Chester Enright. All rights reserved.<br />
			All trademarks are owned by
			their respective parties. Trademarked items are used for the sole purpose of identification
			and do not indicate a relationship between the trademark holder and chetenright.com. All
			Altamont
			Company trademarks are owned by Altamont Company and are used with permission. <br /><br />
			Icons are generously provided by <a href='http://icons8.com'>Icons8</a>. Other icons have been
			sufficiently modified to fall under fair use.
			<br />
		</div>
	</div>

</template>
<script>
import axios from 'axios'
export default {
	name: "Contact",
	data() {
		return {
			received: "",
			url: "https://formspree.io/xnqnvedj",
			name: "Your Name?",
			email: "Your Email?",
			msg: "Type your message here.",
			year: (new Date()).getFullYear()
		}
	},
	methods: {
		sendEmail: function () {
			var form = this.$refs.form
			axios.post(this.url, new FormData(form)).then(res => {
				if (res.status == 200) {
					this.$bvToast.toast('Email Sent!  Thanks!', {
						variant: "success",
						solid: true
					})
				}
			}).catch(e => {
				this.$bvToast.toast(e, {
					variant: "success",
					solid: true
				})

			})
		},
	}
}
</script>
<style lang="scss">
/* Modern Legal Footer */
.legal {
	padding: 20px 20px 16px;
	border-top: 1px solid $border-light;
	margin: 20px auto 0;
	max-width: 1200px;
	text-align: center;
	font-size: 0.8rem;
	color: $text-light;
	line-height: 1.5;
}

.legal a {
	color: $primary;
	text-decoration: none;
	transition: color 0.2s ease;
}

.legal a:hover {
	color: $primary-dark;
	text-decoration: underline;
}

/* Modern Contact Page */

div.contact {
	width: 100%;
	background: transparent;
	padding: 30px 20px;
	max-width: 1200px;
	margin: 0 auto;
	margin-top: 2rem;
	display: flex;
	gap: 20px;
	flex-wrap: wrap;
}

div.contact div.contact_left {
	flex: 1;
	min-width: 260px;
	max-width: 300px;
	background: $bg-white;
	border-radius: $border-radius-md;
	padding: 20px 20px;
	text-align: center;
	box-shadow: $shadow-md;
	border: none;
}

@media screen and (max-width: 1000px) {
	div.contact div.contact_left {
		flex: 1 1 100%;
		max-width: 100%;
		padding: 20px;
	}
}

@media screen and (max-width: 760px) {
	div.contact div.contact_left {
		padding: 20px;
	}
}

div.contact div.contact_left div.text {
	margin-top: 12px;
	line-height: 1.5;
	color: $text-medium;
	font-size: 0.9rem;
}

div.contact div.contact_left div.text b {
	color: $text-dark;
}

@media screen and (max-width: 1000px) {
	div.contact div.contact_left div.text {
		text-align: center;
	}
}

div.contact div.contact_left h2 {
	text-align: center;
}

div.contact div.photo img {
	border-radius: $border-radius-md;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	border: none;
	max-width: 160px;
	height: auto;
}


div.contact div.contact_right {
	flex: 2;
	min-width: 320px;
	background: $bg-white;
	border-radius: $border-radius-md;
	padding: 24px 20px;
	box-shadow: $shadow-md;
}

@media screen and (max-width: 1000px) {
	div.contact div.contact_right {
		flex: 1 1 100%;
		padding: 20px;
	}
}

div.contact div.contact_right h2 {
	text-align: left;
	margin: 0 0 16px 0;
	font-size: 1.35rem;
	font-weight: 700;
	color: $text-dark;
	letter-spacing: 0.2px;
}

div.submit_button {
	width: auto;
	min-width: 200px;
	margin-top: 10px;
	font-size: 1rem;
	font-weight: 600;
	height: auto;
	padding: 14px 32px;
	text-align: center;
	background-color: $primary;
	color: white;
	cursor: pointer;
	float: right;
	border-radius: $border-radius-sm;
	transition: all 0.2s ease;
	box-shadow: $shadow-primary;
}

div.submit_button:hover {
	background-color: $primary-dark;
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

@media screen and (max-width: 760px) {
	div.submit_button {
		width: 100%;
		float: none;
	}
}

div.contact input,
div.contact textarea {
	padding: 12px 16px;
	border: 1px solid $border-light;
	border-radius: $border-radius-sm;
	font-size: 1rem;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	transition: all 0.2s ease;
	box-sizing: border-box;
}

div.contact input:focus,
div.contact textarea:focus {
	outline: none;
	border-color: $primary;
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

div.top_row input#Name {
	width: 49%;
	height: auto;
}

@media screen and (max-width: 760px) {
	div.top_row input#Name {
		width: 100%;
		margin-bottom: 10px;
	}
}

div.top_row input#Email {
	width: 49%;
	float: right;
	height: auto;
}

@media screen and (max-width: 760px) {
	div.top_row input#Email {
		width: 100%;
		float: left;
		margin-bottom: 10px;
	}
}

div.contact_form div.top_row {
	margin-bottom: 10px;
	text-align: left;
}

div.contact_form textarea#Message {
	padding: 12px 16px;
	margin-bottom: 12px;
	width: 100%;
	min-height: 120px;
	resize: vertical;
}

div.contact_form div.captcha_entry {
	float: left;
	width: 50%;
	text-align: left;
}

@media screen and (max-width: 760px) {
	div.contact_form div.captcha_entry {
		width: 100%;
	}
}

div.contact_form div.captcha_entry input#password {
	width: 240px;
	margin-bottom: 10px;
}
</style>
